// Source: BenchmarkSection. Values include intentional inline spacing.
const en = {
  "s1": "Runtime (seconds)",
  "s2": "Fastest of the bunch — 80 s, on a single VM",
  "s3": "Cost (USD)",
  "s4": "Cheapest run here, self-hosted or on GizmoData Cloud",
  "s5": "Total Cost of Query",
  "s6": "Best value, self-hosted or on GizmoData Cloud",
  "s7": "Your data warehouse is ",
  "s8": "overcharging",
  "s9": " you.",
  "s10": "GizmoSQL — the engine inside GizmoData Cloud — ran a full 1 TB workload derived from TPC-H faster than Snowflake, Databricks SQL and BigQuery, for a fraction of the cost. Run the same queries for up to",
  "s11": "90% less",
  "s12": "Up to ",
  "s13": "lower cost",
  "s14": "See DuckDB's hot-run ranking on the ClickBench benchmark (opens in a new tab)",
  "s15": "Top 3",
  "s16": "on ClickBench",
  "cloudRun": "1 TB run derived from TPC-H, on GizmoData Cloud",
  "s18": "Cut my bill in half ",
  "s19": "How we ran 1 TB derived from TPC-H in 80 seconds ",
  "s20": "Comparison of runs derived from TPC-H",
  "s21": "Derived from TPC-H, 1 TB",
  "s22": "Lower is better",
  "s23": "live",
  "s24": "Previous chart",
  "s25": "Next chart",
  "caption": "GizmoSQL: raw AWS EC2 cost on one self-hosted r9gd.24xlarge. GizmoData Cloud: the same run on our managed service.",
  "eyebrow": "A 1 TB workload, measured",
  "headline": "Hardcharger performance, measured",
  "intro": "Run analytical SQL over an open protocol, with DuckDB 2.0 doing the work. Here are the measured query times and raw compute costs, with the methods and caveats linked below.",
  "runtimeStat": "Query time",
  "costStat": "AWS compute / run",
  "queryStat": "Queries × runs",
  "runContext": "Sum of the 22 per-query means, three runs per query, on one AWS Graviton5 VM. Cold first runs included.",
  "methods": "Read the methods and results",
  "runCloud": "Run Hardcharger on GizmoData Cloud",
  "metricLabel": "Chart metric",
  "comparisonContext": "Hardcharger uses the fresh DuckDB 2.0 run. Other systems are historical published results on different hardware and software versions; see the methodology for context.",
  "costContext": "Server costs are raw AWS on-demand compute, excluding storage and managed-service charges; not a TPC price/performance metric."
};
const pt: typeof en = {
  "s1": "Tempo de execução (segundos)",
  "s2": "O mais rápido do grupo — 80 s, em uma única VM",
  "s3": "Custo (USD)",
  "s4": "A execução mais barata daqui, auto-hospedada ou no GizmoData Cloud",
  "s5": "Custo total da consulta",
  "s6": "A melhor relação custo-benefício, auto-hospedado ou no GizmoData Cloud",
  "s7": "Seu data warehouse está ",
  "s8": "cobrando demais",
  "s9": " de você.",
  "s10": "O GizmoSQL — o mecanismo por trás do GizmoData Cloud — executou uma carga de trabalho completa de 1 TB derivada do TPC-H mais rápido que Snowflake, Databricks SQL e BigQuery, por uma fração do custo. Execute as mesmas consultas por até",
  "s11": "90% menos",
  "s12": "Até ",
  "s13": "menos custo",
  "s14": "Veja a classificação do DuckDB com cache aquecido no benchmark ClickBench (abre em uma nova aba)",
  "s15": "Entre os 3 melhores",
  "s16": "no ClickBench",
  "cloudRun": "execução de 1 TB derivada do TPC-H, no GizmoData Cloud",
  "s18": "Reduzir minha conta pela metade ",
  "s19": "Como executamos 1 TB derivado do TPC-H em 80 segundos ",
  "s20": "Comparação de execuções derivadas do TPC-H",
  "s21": "Derivado do TPC-H, 1 TB",
  "s22": "Quanto menor, melhor",
  "s23": "ao vivo",
  "s24": "Gráfico anterior",
  "s25": "Próximo gráfico",
  "caption": "GizmoSQL: custo bruto de EC2 da AWS em uma única r9gd.24xlarge auto-hospedada. GizmoData Cloud: a mesma execução no nosso serviço gerenciado.",
  "eyebrow": "Uma carga de 1 TB, medida",
  "headline": "Desempenho do Hardcharger, medido",
  "intro": "Execute SQL analítico por um protocolo aberto, com o DuckDB 2.0 fazendo o trabalho. Veja os tempos de consulta e custos brutos de computação medidos, com os métodos e ressalvas nos links abaixo.",
  "runtimeStat": "Tempo de consulta",
  "costStat": "Computação AWS / execução",
  "queryStat": "Consultas × execuções",
  "runContext": "Soma das médias das 22 consultas, com três execuções por consulta, em uma VM AWS Graviton5. Inclui as primeiras execuções a frio.",
  "methods": "Leia os métodos e resultados",
  "runCloud": "Execute o Hardcharger no GizmoData Cloud",
  "metricLabel": "Métrica do gráfico",
  "comparisonContext": "O Hardcharger usa a nova execução com DuckDB 2.0. Os demais sistemas são resultados históricos publicados em hardware e versões de software diferentes; consulte a metodologia para o contexto.",
  "costContext": "Os custos dos servidores são os valores brutos de computação AWS sob demanda, sem armazenamento nem taxas de serviço gerenciado; não são uma métrica TPC de preço/desempenho."
};
export default { en, 'pt-BR': pt };
